import "@fontsource/roboto"; // Defaults to weight 400
import "@fontsource/roboto/400.css"; // Specify weight
import "@fontsource/roboto/400-italic.css"; // Specify weight and style
import "@fontsource/orbitron"; // Defaults to weight 400
import "@fontsource/orbitron/400.css"; // Specify weight

import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import { Home } from "./pages/home/home";
import { Contact } from "./pages/contact/contact";
import { Services } from "./pages/services/services";
import { About } from "./pages/about/about";
import { News } from "./pages/news/news";

import { Art3D } from "./pages/sub.pages/3d.art";
import { Assets3D } from "./pages/sub.pages/assets";
import { Audio } from "./pages/sub.pages/audio.design";
import { DevelopmentTools } from "./pages/sub.pages/development.tools";
import { GameDevelopment } from "./pages/sub.pages/game.development";

import { Footer } from "./components/footer/footer";
import { Navbar } from "./components/navbar/navbar";
import { MasterDiv } from "./components/master.div";
import { useIsMobile } from "./hooks/is.mobile";
// import { useEffect } from "react";
import { UseScrollToTop } from "./hooks/scroll.to.top";

function App() {
  // useEffect(() => {
  //   document.title = "VH-Interactive";
  // }, []);
  // const isMobile = useIsMobile();
  return (
    <div>
      <header className="App-header">
        <Router>
          <UseScrollToTop />
          <MasterDiv zDepth={9999}>
            <Navbar></Navbar>
          </MasterDiv>
          <MasterDiv zDepth={1} color={true}>
            <div
              style={{
                minHeight: "100vh",
                display: "flex",
                flexFlow: "column",
              }}
            >
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/art3D" element={<Art3D />} />
                <Route path="/3dassets" element={<Assets3D />} />
                <Route path="/audio" element={<Audio />} />
                <Route path="/news" element={<News />} />
                <Route
                  path="/development-tools"
                  element={<DevelopmentTools />}
                />
                <Route path="/game-development" element={<GameDevelopment />} />
              </Routes>
              <div style={{ flexGrow: "1" }}></div>
              <Footer />
            </div>
          </MasterDiv>
        </Router>
      </header>
    </div>
  );
}

export default App;
